import { basePathRewrite } from '@components/common';
import JobsAction from '@components/jobsAction/jobAction';
import { Button, useDeviceType } from '@license-admin/boldfjcomponents';
import { isRCPortal } from 'helper';
import { ActionWrapper, Container, ContentWrapper, Heading } from './styled';
interface ErrorPageProps {
  statusCode: number;
}
const ErrorPageWrap: React.FC<ErrorPageProps> = ({ statusCode }) => {
  const isDesktopView = useDeviceType() === 'desktop';

  return (
    <Container isRCPortal={isRCPortal}>
      <ContentWrapper isRCPortal={isRCPortal} isMobileView={!isDesktopView}>
        <Heading isRCPortal={isRCPortal}>
          {statusCode === 404
            ? 'Oops, This Page Could Not Be Found!'
            : `An error ${statusCode} occurred.`}
        </Heading>

        <p className="content-para">
          {statusCode === 404
            ? 'We’re really sorry, something didn’t work as intended. Our help crew is on the way!'
            : 'We can’t find the page you are looking for.'}
          In the meantime,{' '}
          <a href={basePathRewrite('/contact')} className="para-link">
            contact us
          </a>{' '}
          if you need help finding your way.
        </p>

        <div className="btn-wrapper">
          <Button text="Go to Homepage" url="/" />
        </div>
      </ContentWrapper>
      {isDesktopView && (
        <ActionWrapper>
          <JobsAction isRCPortal={isRCPortal} isLoggedIn={true} />
        </ActionWrapper>
      )}
    </Container>
  );
};
export default ErrorPageWrap;
